import React, { useState } from "react";
import CustomerRegistractionForm2 from "../../Customer Panel/Customer_Registraction_Form2";
import "./BookNow.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";

const BookNowButton = () => {
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [pop, setPop] = useState(false); // For animation effect

  const openBookingModal = () => {
    setShowBookingModal(true);
  };

  const closeBookingModal = () => {
    setShowBookingModal(false);
  };

  return (
    <>
      <div
        className={`Sidebar_footer_icon_Booknow ${pop ? "pop-animation" : ""}`}
        onClick={() => {
          setPop(true);
          setTimeout(() => setPop(false), 300); // Reset pop animation
          openBookingModal();
        }}
      >
{/* <FontAwesomeIcon icon={faShoppingCart} size="2x" className="cart-icon" /> */}
BOOK <br/> NOW!
</div>

      {showBookingModal && (
        <CustomerRegistractionForm2 
          show={showBookingModal}
          handleClose={closeBookingModal}
        />
      )}
    </>
  );
};

export default BookNowButton;
